import type { F01InsightCell } from "@care-by-ella/contracts";

// TES-1326 — display helpers for the F-01 insight view, kept pure so they
// can be tested without a DOM.

const fmt = new Intl.NumberFormat("sv-SE");

const MONTHS = [
  "januari",
  "februari",
  "mars",
  "april",
  "maj",
  "juni",
  "juli",
  "augusti",
  "september",
  "oktober",
  "november",
  "december",
];

/** A count as shown: the rounded number, or why it is hidden. */
export function formatCell(cell: F01InsightCell): string {
  return cell.n === null ? `Dold (färre än ${cell.min})` : fmt.format(cell.n);
}

export function formatShare(share: number | null): string {
  return share === null ? "–" : `${share} %`;
}

/** "all" | "2026-10" | "2026-Q4" as a Swedish label. */
export function periodLabel(period: string): string {
  if (period === "all") return "Sedan start";
  const quarter = /^(\d{4})-Q([1-4])$/.exec(period);
  if (quarter) return `Kvartal ${quarter[2]} ${quarter[1]}`;
  const month = /^(\d{4})-(\d{2})$/.exec(period);
  if (month) return `${MONTHS[Number(month[2]) - 1]} ${month[1]}`;
  return period;
}

export const BREAKDOWN_LABELS = {
  cohort: "Steg i patientresan",
  channel: "Kanal",
  version: "Formulärversion",
} as const;
